import { NewModal } from 'lib/components';
import { Gap } from 'lib/components/styles/layout';
import {
  ParagraphNormalBold,
  ParagraphSmall,
} from 'lib/components/styles/typography';
import { ReactComponent as VisibilityOverlay } from 'assets/icons/visibility/overlay.svg';
import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import howToShareOne from '../assets/images/how-to-share-1.png';
import howToShareTwo from '../assets/images/how-to-share-2.png';
import { HOW_TO_SHARE_MODAL } from '../const';
import { Button } from 'react-covideo-common';
import { Trans, useTranslation } from 'react-i18next';

const Content = styled.div`
  border-radius: 8px;
  border: 1px solid #eeeff2;
  background: #fafafc;
  padding: 32px 16px 0 16px;
  position: relative;
`;
const Overlay = styled.div`
  height: 48px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
`;

interface IProps {
  closeModalHandler: () => void;
}

const SpanNormalBold = styled(ParagraphNormalBold).attrs({ as: 'span' })``;

export const HowToShareModal = ({ closeModalHandler }: IProps) => {
  const { t } = useTranslation();
  useEffect(() => {
    localStorage.setItem(HOW_TO_SHARE_MODAL, 'visited');
  }, []);

  return (
    <NewModal
      headerText={t('How to share training videos')}
      closeModal={closeModalHandler}
      style={{
        content: {
          maxWidth: '100%',
        },
      }}
    >
      <Content>
        <Gap gap='36px' justifyContent='space-between'>
          <Gap flexDirection='column'>
            <ParagraphSmall textAlign='center'>
              <Trans
                i18nKey='shareAll'
                components={{
                  0: <SpanNormalBold as='span' />,
                  1: <br />,
                  2: <SpanNormalBold as='span' />,
                }}
              />
            </ParagraphSmall>
            <img src={howToShareOne} alt='how to share' />
          </Gap>

          <Gap flexDirection='column'>
            <ParagraphSmall textAlign='center'>
              <Trans
                i18nKey='shareManual'
                components={{
                  0: <SpanNormalBold as='span' />,
                  1: <br />,
                  2: <SpanNormalBold as='span' />,
                }}
              />
            </ParagraphSmall>
            <img src={howToShareTwo} alt='how to share' />
          </Gap>
        </Gap>
        <Overlay>
          <VisibilityOverlay />
        </Overlay>
      </Content>
      <Gap width='100%' justifyContent='flex-end' m='32px 0 0 0'>
        <Button
          text={t('I understand')}
          onClick={closeModalHandler}
          variant='primary'
        />
      </Gap>
    </NewModal>
  );
};
